import React from "react"
import PropTypes from "prop-types";

 const TemplateEmptyImage = ({ height = 140, width = 140, fill = "var(--color-primary)", ...props }) => {
  return (
 <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 129 129" fill="none">
<rect width="128.595" height="128.595" rx="64.2975" fill="#F9FBFB"/>
<path d="M91.3801 90.3783L45.974 95.5863L39.3281 37.6445L83.5092 32.577L91.3801 90.3783Z" fill="#000066"/>
<path d="M38.0273 37.1133L83.4334 31.9053L90.0793 89.8471L44.6732 95.0551L38.0273 37.1133Z" fill="white"/>
<path d="M45.0742 41.9102L77.6588 38.1727L77.6876 38.4236L45.103 42.161L45.0742 41.9102Z" fill={fill}/>
<path d="M45.9805 49.8125L78.5651 46.0751L78.5939 46.326L46.0092 50.0634L45.9805 49.8125Z" fill={fill}/>
<path d="M46.8867 57.7109L79.4713 53.9735L79.5001 54.2244L46.9155 57.9618L46.8867 57.7109Z" fill={fill}/>
<path d="M47.793 65.6133L80.3776 61.8759L80.4064 62.1267L47.8217 65.8641L47.793 65.6133Z" fill={fill}/>
<path d="M48.6992 73.5156L81.2838 69.7782L81.3126 70.0291L48.728 73.7665L48.6992 73.5156Z" fill={fill}/>
<path d="M49.6055 81.418L82.1901 77.6806L82.2189 77.9314L49.6342 81.6688L49.6055 81.418Z" fill={fill}/>
<path d="M42.0394 40.6675C42.7327 40.5879 43.2303 39.9614 43.1507 39.2681C43.0712 38.5748 42.4447 38.0773 41.7514 38.1568C41.0581 38.2363 40.5606 38.8628 40.6401 39.5561C40.7196 40.2494 41.3461 40.747 42.0394 40.6675Z" fill="#000066"/>
<path d="M80.7933 36.226C81.4866 36.1465 81.9842 35.52 81.9046 34.8267C81.8251 34.1334 81.1986 33.6359 80.5053 33.7154C79.812 33.7949 79.3145 34.4214 79.394 35.1147C79.4735 35.808 80.1 36.3056 80.7933 36.226Z" fill="#000066"/>
</svg>
)
 }
TemplateEmptyImage.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string,
};

export default TemplateEmptyImage